// * Hub tabs: mark the nav-pill matching the current page as active.
//
// The nav has links like /hub/1, /hub/1/resources, /hub/1/collections,
// /hub/1/members. We pick the link whose href best matches the current
// pathname and apply the active state to it.

export function initHubTabs() {
  const tabList = document.getElementById('hubTabs');
  if (!tabList) {
    return;
  }

  const links = [...tabList.querySelectorAll('.nav-link')];
  if (links.length === 0) {
    return;
  }

  const normalize = (path) =>
    path.replace(/\/+$/, '') || '/';

  const current = normalize(window.location.pathname);

  // Find the link with the longest matching href, so /hub/1/resources wins
  // over /hub/1 when both are prefixes of the current path.
  let best = null;
  let bestLength = -1;

  for (const link of links) {
    const href = normalize(new URL(link.href, window.location.origin).pathname);

    if (current === href || current.startsWith(`${href}/`)) {
      if (href.length > bestLength) {
        best = link;
        bestLength = href.length;
      }
    }
  }

  for (const link of links) {
    const isActive = link === best;
    link.classList.toggle('active', isActive);
    if (isActive) {
      link.setAttribute('aria-current', 'page');
    } else {
      link.removeAttribute('aria-current');
    }
  }
}
